import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const cronJobsService = {
  _url: process.env.REACT_APP_CRONJOB_API_URL || 'https://sse-feedalabs.webevis.com',
  _platformId: 'coinpilotlabs',

  GetJobsList(fetch) {
    const [data, setsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllJobs())
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [fetch]);

    return {
      _jobs_loading: status === STATUS.LOADING,
      _jobs_error: status === STATUS.ERROR,
      _jobs_data: data,
    };
  },

  async getAllJobs() {
    return await Fetch.get(`${this._url}/cronjob/list?platform_id=${encodeURIComponent(this._platformId)}`);
  },

  async createJob(payload) {
    return await Fetch.post(`${this._url}/cronjob/add`, {
      ...payload,
      platform_id: payload.platform_id || this._platformId,
    });
  },

  async updateJob(payload) {
    return await Fetch.put(`${this._url}/cronjob/update`, {
      ...payload,
      platform_id: payload.platform_id || this._platformId,
    });
  },

  async deleteJob(id) {
    return await Fetch.delete(`${this._url}/cronjob/delete?cronjob_id=${encodeURIComponent(id)}`);
  },
};

export default cronJobsService;
